import { BiCamera } from "react-icons/bi"; 
import { CiCamera } from "react-icons/ci"; 
import { RiAttachment2 } from "react-icons/ri"; 
import { ImAttachment } from "react-icons/im"; 
import { CgAttachment } from "react-icons/cg"; 
import { AiOutlineDownload } from "react-icons/ai"; 
import { FcDownload } from "react-icons/fc"; 
import { IoIosSend } from "react-icons/io"; 
import { MdFavoriteBorder } from "react-icons/md"; 
import { MdFavorite } from "react-icons/md"; 
import { BsCardList } from "react-icons/bs"; 
import { BsCardChecklist } from "react-icons/bs"; 
import { BsPersonVcard } from "react-icons/bs"; 
import { BsCreditCard2Front } from "react-icons/bs"; 
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { scheduleMessage, getScheduled, subscribe, cancelScheduled } from '../../utils/messageScheduler';
import { compressImages } from '../../utils/imageUtils';
import MessageImages from '../../components/MessageImages';
const API_URL = process.env.REACT_APP_API_URL;

const ProfileSearch = ({ occupations, annualIncomes, updateUserPoints, showConfirmationDialog, user }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchFilters, setSearchFilters] = useState({
    occupation: '',
    annual_income: '',
    excludeSameSex: true
  });
  const [viewMode, setViewMode] = useState('grid'); // grid, card, list
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [showProfileDetailsModal, setShowProfileDetailsModal] = useState(false);
  const [favoriteUserIds, setFavoriteUserIds] = useState([]); // State to track favorites
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  // Message sending state
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [message, setMessage] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [decuctPoint, setDeductPoint] = useState(0);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [fullConversationHistory, setFullConversationHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [loadingFullHistory, setLoadingFullHistory] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]);
  const [isCompressingImages, setIsCompressingImages] = useState(false);

  // Scheduling state
  const [enableSchedule, setEnableSchedule] = useState(false);
  const [scheduledAt, setScheduledAt] = useState('');
  const [scheduledItems, setScheduledItems] = useState([]);

  // Avatar modal state
  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState(null);

  // Resolve recipient name from search results
  const resolveRecipientName = (id) => {
    const profile = searchResults.find(p => p._id === id);
    return profile?.name || '不明';
  };

  // Emoji list for quick selection
  const emojis = ['😊', '😄', '😍', '🥰', '😘', '😉', '😎', '🤗', '👍', '❤️', '💕', '💖', '💝', '🌹', '🌸', '✨', '🎉', '🎊', '🎈', '🎁'];

  // Fetch current user's favorites on load
  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFavoriteUserIds(response.data.favoriteUserIds || []);
        setDeductPoint(response.data.sendPoints);
        setCurrentUserId(response.data._id);
        // console.log("user-me", decuctPoint);
      } catch (error) {
        console.error('Error fetching favorites:', error);
      }
    };
    fetchFavorites();
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const unsubscribe = subscribe((items) => {
      setScheduledItems(items.filter((it) => it.source === 'user:profile-search'));
    });
    setScheduledItems(getScheduled().filter((it) => it.source === 'user:profile-search'));
    return () => unsubscribe();
  }, []);

  const searchProfiles = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/users/search`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          occupation: searchFilters.occupation,
          annual_income: searchFilters.annual_income,
          excludeSameSex: searchFilters.excludeSameSex
        }
      });
      setSearchResults(response.data);
    } catch (error) {
      console.error('Error searching profiles:', error);
      alert('プロフィール検索に失敗しました');
    }
  };

  
  const viewProfileDetails = async (profile) => {
    try {
      const token = localStorage.getItem('token');
      
      // Check if user has enough points for profile view
      const pointCheckResponse = await axios.get(`${API_URL}/api/point-costs`);
      const profileViewCost = pointCheckResponse.data.find(cost => cost.actionName === 'profile_view');
      
      if (profileViewCost && profileViewCost.pointCost > 0) {
        // Deduct points for viewing profile
        const deductResponse = await axios.post(`${API_URL}/api/users/deduct-points`, {
          actionName: 'profile_view',
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (deductResponse.data.success) {
          // Update user points immediately
          updateUserPoints(deductResponse.data.remainingPoints);
          // No success alert
        } else {
          alert(`ポイントが不足しています。\n必要ポイント: ${deductResponse.data.required}pt\n所持ポイント: ${deductResponse.data.available}pt`);
          return;
        }
      }
      
      setSelectedProfile(profile);
      setShowProfileDetailsModal(true);
    } catch (error) {
      console.error('Error viewing profile details:', error);
      alert('あなたのポイント数が足りません。!');
    }
  };

  const handleFavorite = async (userIdToFavorite) => {
    try {
      const token = localStorage.getItem('token');
      if (isFavorite(userIdToFavorite)) {
        // Remove from favorites
        console.log("userIDtofavorites", userIdToFavorite);
        await axios.post(`${API_URL}/api/users/unfavorite`, { favoriteUserId: userIdToFavorite }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFavoriteUserIds(prev => prev.filter(id => id !== userIdToFavorite));
        alert('お気に入りから削除しました！');
      } else {
        // Add to favorites
        await axios.post(`${API_URL}/api/users/favorite`, { favoriteUserId: userIdToFavorite }, {
          headers: { Authorization: `Bearer ${token}` }
          
        });
        setFavoriteUserIds(prev => [...prev, userIdToFavorite]);
        alert('お気に入りに追加しました！');
        // console.log(searchResults);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
      // alert(error.response?.data?.message || 'お気に入り操作に失敗しました。`````');
    }
  };

  const handleSendMessage = async (user) => {
    setSelectedUser(user);
    setShowMessageModal(true);
    setMessage('');
    setEnableSchedule(false);
    setScheduledAt('');
    
    // Fetch conversation history
    if (user._id) {
      setLoadingHistory(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/api/messages/conversation/${user._id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setConversationHistory(response.data);
      } catch (error) {
        console.error('Error fetching conversation history:', error);
        setConversationHistory([]);
      } finally {
        setLoadingHistory(false);
      }
    }
  };

  const openFullHistoryInNewTab = () => {
    if (!selectedUser) return;
    
    // Use pre-fetched full history (200 messages)
    const history = fullConversationHistory.length > 0 ? fullConversationHistory : conversationHistory;
    const doc = window.open('', '_blank');
    if (!doc) return;
    
    const title = `${selectedUser.name || '不明'}とのやり取り履歴`;
    const html = `<!doctype html>
<html lang="ja">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>${title}</title>
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans JP', 'Hiragino Kaku Gothic ProN', Meiryo, sans-serif; margin: 20px; padding-bottom: 80px; background: #f5f5f5; }
    h2 { margin: 0 0 16px; color: #333; }
    .msg { border: 1px solid #ddd; border-radius: 8px; padding: 10px 12px; margin: 8px 0; background: white; cursor: pointer; transition: box-shadow 0.2s; }
    .msg:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
    .meta { color: #666; font-size: 12px; margin-bottom: 6px; }
    .from { font-weight: bold; color: #34495e; }
    .body { word-wrap: break-word; overflow-wrap: break-word; line-height: 1.6; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .from-me { background-color: #e3f2fd; border-left: 3px solid #2196f3; }
    .from-other { background-color: #f5f5f5; border-left: 3px solid #4caf50; }
    .back-button { position: fixed; bottom: 20px; right: 20px; background-color: #2196f3; color: white; border: none; padding: 12px 24px; border-radius: 5px; cursor: pointer; font-size: 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.2); }
    .back-button:hover { background-color: #1976d2; }
    .modal { display: none; position: fixed; z-index: 1000; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); }
    .modal-content { background-color: white; margin: 5% auto; padding: 20px; border-radius: 10px; width: 80%; max-width: 600px; max-height: 70vh; overflow-y: auto; }
    .close-modal { color: #999; float: right; font-size: 28px; font-weight: bold; cursor: pointer; }
    .close-modal:hover { color: #333; }
    .modal-body { white-space: pre-wrap; word-wrap: break-word; line-height: 1.6; margin-top: 10px; }
  </style>
  <script>
    function openModal(content, sender, date) {
      const modal = document.getElementById('messageModal');
      document.getElementById('modalSender').textContent = sender;
      document.getElementById('modalDate').textContent = date;
      document.getElementById('modalBody').textContent = content;
      modal.style.display = 'block';
    }
    function closeModal() {
      document.getElementById('messageModal').style.display = 'none';
    }
    window.onclick = function(event) {
      const modal = document.getElementById('messageModal');
      if (event.target == modal) {
        closeModal();
      }
    }
  </script>
</head>
<body>
  <h2>${title} (直近200件)</h2>
  ${history.map(h => {
    const isFromMe = h.from_userID?._id === currentUserId;
    const escapedBody = (h.body || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g,'&gt;').replace(/'/g, '&apos;').replace(/"/g, '&quot;');
    const sender = (h.from_userID?.name || '不明').replace(/'/g, '&apos;');
    const date = new Date(h.created_at).toLocaleString('ja-JP');
    return `
    <div class="msg ${isFromMe ? 'from-me' : 'from-other'}" onclick="openModal('${escapedBody}', '${sender}', '${date}')">
      <div class="meta">
        <span class="from">${h.from_userID?.name || '不明'}</span>
        ／ ${date}
      </div>
      <div class="body">${escapedBody}</div>
    </div>
  `;
  }).join('')}
  <div id="messageModal" class="modal">
    <div class="modal-content">
      <span class="close-modal" onclick="closeModal()">&times;</span>
      <h3 id="modalSender"></h3>
      <p style="color: #666; font-size: 12px;" id="modalDate"></p>
      <div class="modal-body" id="modalBody"></div>
    </div>
  </div>
  <button class="back-button" onclick="window.close()">戻る</button>
</body>
</html>`;
    doc.document.open();
    doc.document.write(html);
    doc.document.close();
  };

  const addEmoji = (emoji) => {
    setMessage(prev => prev + emoji);
    setShowEmojiPicker(false);
  };

  const handleImageSelect = async (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.filter(file => file.type.startsWith('image/') && !file.type.startsWith('video/'));
    
    if (imageFiles.length === 0) {
      alert('画像ファイルを選択してください（動画ファイルは除く）');
      return;
    }

    if (selectedImages.length + imageFiles.length > 10) {
      alert('画像は最大10枚まで選択できます');
      return;
    }

    setIsCompressingImages(true);
    try {
      const compressedImages = await compressImages(imageFiles);
      setSelectedImages(prev => [...prev, ...compressedImages]);
      setImagePreviewUrls(prev => [...prev, ...compressedImages]);
      // NOTE: Do not inject placeholder text into textarea; images are shown via previews/thumbnails.
    } catch (error) {
      console.error('Error compressing images:', error);
      alert('画像の圧縮に失敗しました');
    } finally {
      setIsCompressingImages(false);
    }
  };

  const removeImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviewUrls(prev => prev.filter((_, i) => i !== index));
  };

  const sendMessage = async () => {
    if (!message.trim() && selectedImages.length === 0) {
      alert('メッセージまたは画像を入力してください');
      return;
    }

    // If scheduled in the future, queue instead of immediate send
    if (enableSchedule && scheduledAt) {
      const when = new Date(scheduledAt);
      if (when.getTime() > Date.now()) {
        // Check if user has enough points for scheduled message
        // try {
        //   const token = localStorage.getItem('token');
        //   const pointCheckResponse = await axios.get(`${API_URL}/api/point-costs`);
        //   const sendMessageCost = pointCheckResponse.data.find(cost => cost.actionName === 'send_message');
        //   sendMessageCost.pointCost = decuctPoint;
          
        //   if (sendMessageCost && sendMessageCost.pointCost > 0) {
        //     // Check if user has enough points
        //     const deductResponse = await axios.post(`${API_URL}/api/users/deduct-points`, {
        //       actionName: 'send_message'
        //     }, {
        //       headers: { Authorization: `Bearer ${token}` }
        //     });
            
        //     if (!deductResponse.data.success) {
        //       alert(`ポイントが不足しています。\n必要ポイント: ${deductResponse.data.required}pt\n所持ポイント: ${deductResponse.data.available}pt`);
        //       return;
        //     }
        //   }
        // } catch (error) {
        //   console.error('Error checking points for scheduled message:', error);
        //   alert('ポイント確認に失敗しました。メッセージの予約を続行しますか？');
        //   // Continue with scheduling even if point check fails
        // }
        
        scheduleMessage({
          recipients: [selectedUser._id],
          content: message,
          images: selectedImages,
          scheduledAt: when.toISOString(),
          source: 'user:profile-search',
          type: 'direct',
          needsPointDeduction: true
        });
        setShowMessageModal(false);
        setMessage('');
        setSelectedImages([]);
        setImagePreviewUrls([]);
        setSelectedUser(null);
        setConversationHistory([]);
        setFullConversationHistory([]);
        return;
      }
    }

    try {
      const token = localStorage.getItem('token');
      
      // Check if user has enough points for sending message
      const pointCheckResponse = await axios.get(`${API_URL}/api/point-costs`);
      const sendMessageCost = pointCheckResponse.data.find(cost => cost.actionName === 'send_message');
      sendMessageCost.pointCost = decuctPoint;
      if (sendMessageCost && sendMessageCost.pointCost >= 0) {
        // Deduct points for sending message
        const deductResponse = await axios.post(`${API_URL}/api/users/deduct-points`, {
          actionName: 'send_message'
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        

        // const deductResponse = decuctPoint;
        if (!deductResponse.data.success) {
          alert(`ポイントが不足しています。\n必要ポイント: ${deductResponse.data.required}pt\n所持ポイント: ${deductResponse.data.available}pt`);
          return;
        }
        
        // Update user points immediately
        updateUserPoints(deductResponse.data.remainingPoints);
      }
      
      // Send the actual message
      await axios.post(`${API_URL}/api/messages/recipientId`, {
        userId: selectedUser._id,
        content: message,
        images: selectedImages
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setShowMessageModal(false);
      setMessage('');
      setSelectedImages([]);
      setImagePreviewUrls([]);
      setSelectedUser(null);
      setConversationHistory([]);
      setFullConversationHistory([]);
    } catch (error) {
      console.error('Error sending message:', error);
      alert(error.response?.data?.message || 'メッセージの送信に失敗しました');
    }
  };

  const isFavorite = (userId) => favoriteUserIds.includes(userId); // Check if user is favorite

  // Handle avatar click to show in modal
  const handleAvatarClick = (profile) => {
    if (profile.photoLink) {
      setSelectedAvatar({
        src: profile.photoLink.photodatas || profile.photoLink,
        name: profile.name || '未設定',
        userID: profile.userID || '未設定'
      });
      setShowAvatarModal(true);
    }
  };

  // Download avatar image
  const downloadAvatar = () => {
    if (selectedAvatar) {
      const link = document.createElement('a');
      link.href = selectedAvatar.src;
      link.download = `${selectedAvatar.name || 'avatar'}_${selectedAvatar.userID || 'profile'}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const HeartButton = ({ userId }) => (
    <button
      onClick={() => handleFavorite(userId)}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '20px',
        color: isFavorite(userId) ? '#f53754ff' : '#bbb',
        // marginLeft: '8px',
        marginTop:'5px',
        verticalAlign: 'middle'
      }}
      title={isFavorite(userId) ? 'お気に入り済み' : 'お気に入りに追加'}
    >
      {isFavorite(userId) ? <MdFavorite />: <MdFavoriteBorder />}
    </button>
  );

  return (
    <div>
      <h2 style={{ color: '#333', marginBottom: '20px' }}>プロフィール検索</h2>

      {/* Scheduled Items Panel */}
      {scheduledItems.length > 0 && (
        <div style={{
          marginBottom: '15px',
          backgroundColor: 'white',
          border: '1px dashed #f39c12',
          padding: '10px',
          borderRadius: '6px'
        }}>
          <div style={{ fontWeight: 'bold', color: '#f39c12', marginBottom: '8px' }}>⏳ 予約中のメッセージ</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {scheduledItems.map((it) => (
              <div key={it.id} style={{
                border: '1px solid #f8c471',
                borderRadius: '4px',
                padding: '6px 8px',
                background: it.status === 'failed' ? '#fdecea' : '#fcf3cf'
              }}>
                <div style={{ fontSize: '12px' }}>
                  <span style={{ marginRight: '6px' }}>🕒 {new Date(it.scheduledAt).toLocaleString('ja-JP')}</span>
                  <span style={{ color: '#7f8c8d' }}>{it.type}</span>
                  <span style={{ marginLeft: '8px', color: '#34495e' }}>宛先: {resolveRecipientName(Array.isArray(it.recipients) ? it.recipients[0] : it.recipients)}</span>
                  {it.status === 'failed' && (
                    <span style={{ color: '#e74c3c', marginLeft: '6px' }}>失敗: {it.lastError}</span>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
                  <button
                    onClick={() => { if (window.confirm('この予約を取り消しますか？')) { cancelScheduled(it.id); } }}
                    style={{
                      background: '#e74c3c',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '4px 8px',
                      fontSize: '12px',
                      cursor: 'pointer'
                    }}
                  >
                    取り消し
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Search Filters */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        
        <button
          onClick={searchProfiles}
          style={{
            backgroundColor: '#ff6b35',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          検索
        </button>
      </div>

      {/* View Mode Toggle */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '15px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
      </div>

      {/* Search Results */}
      {searchResults.length > 0 && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px'
        }}>
          <h3 style={{ marginBottom: '15px' }}>検索結果 ({searchResults.length}件)</h3>
          
          {viewMode === 'grid' && (
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
              gap: '20px' 
            }}>
              {searchResults.map((profile, index) => (
                <div key={profile._id || index} style={{ 
                  border: '1px solid #ddd', 
                  borderRadius: '8px', 
                  padding: '15px',
                  textAlign: 'center'
                }}>
                  {profile.photoLink ? (
                    <img 
                      src={profile.photoLink.photodatas || profile.photoLink} 
                      alt="Profile" 
                      onClick={() => handleAvatarClick(profile)}
                      style={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '50%', 
                        marginBottom: '0px',
                        objectFit: 'cover',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease'
                      }}
                      onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                    />
                  ) : (
                    <div style={{ 
                      width: '80px', 
                      height: '80px', 
                      borderRadius: '50%', 
                      backgroundColor: '#ddd',
                      margin: '0 auto 10px auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      写真なし
                    </div>
                  )}
                  <h4 style={{ margin: '5px 0' }}>{profile.name || '未設定'}</h4>
                  
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '0px' }}>
                    <button
                      onClick={() => handleSendMessage(profile)}
                      style={{
                        backgroundColor: 'white',
                        
                        color: '#2196F3',
                        border: 'none',
                        // padding: '8px 16px',
                        marginTop:'5px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize:'20px'
                      }}
                    >
                       <IoIosSend />
                    </button>
                    <HeartButton  userId={profile._id} />
                  </div>
                </div>
              ))}
            </div>
          )}

          {viewMode === 'card' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {searchResults.map((profile, index) => (
                <div key={profile._id || index} style={{ 
                  border: '1px solid #ddd', 
                  borderRadius: '8px', 
                  padding: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px'
                }}>
                  {profile.photoLink ? (
                    <img 
                      src={profile.photoLink.photodatas || profile.photoLink} 
                      alt="Profile" 
                      onClick={() => handleAvatarClick(profile)}
                      style={{ 
                        width: '100px', 
                        height: '100px', 
                        borderRadius: '50%',
                        objectFit: 'cover',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease'
                      }}
                      onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                    />
                  ) : (
                    <div style={{ 
                      width: '100px', 
                      height: '100px', 
                      borderRadius: '50%', 
                      backgroundColor: '#ddd',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      写真なし
                    </div>
                  )}
                  <div style={{ flex: 1 }}>
                    <h4 style={{ margin: '5px 0' }}>{profile.name || '未設定'}</h4>
                    <p style={{ margin: '5px 0', color: '#666' }}>
                      職業: {profile.occupation?.occupaionName || '未設定'}
                    </p>
                    <p style={{ margin: '5px 0', color: '#666' }}>
                      年収: {profile.annual_income?.annualIncome || '未設定'}
                    </p>
                    <p style={{ margin: '5px 0', color: '#666' }}>
                      登録日: {new Date(profile.createdAt).toLocaleDateString('ja-JP')}
                    </p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <button
                      onClick={() => viewProfileDetails(profile)}
                      style={{
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                    >
                      詳細を見る
                    </button>
                    <button
                      onClick={() => handleSendMessage(profile)}
                      style={{
                        backgroundColor: 'white',
                        color: '#2196F3',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '5px',
                        marginTop:'5px',
                        fontSize:'20px',
                        cursor: 'pointer'
                      }}
                    >
                      <IoIosSend />
                    </button>
                    <HeartButton userId={profile._id} />
                  </div>
                </div>
              ))}
            </div>
          )}

          {viewMode === 'list' && (
            <div style={{ border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5' }}>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>写真</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>名前</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>職業</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>年収</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>登録日</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((profile, index) => (
                    <tr key={profile._id || index} style={{ borderBottom: '1px solid #eee' , }}>
                      <td style={{ padding: '12px'  }}>
                        {profile.photoLink ? (
                          <img 
                            src={profile.photoLink.photodatas || profile.photoLink} 
                            alt="Profile" 
                            onClick={() => handleAvatarClick(profile)}
                            style={{ 
                              width: '50px', 
                              height: '50px', 
                              borderRadius: '50%',
                              objectFit: 'cover',
                              cursor: 'pointer',
                              transition: 'transform 0.2s ease'
                            }}
                            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                          />
                        ) : (
                          <div style={{ 
                            width: '50px', 
                            height: '50px', 
                            borderRadius: '50%', 
                            backgroundColor: '#ddd',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px'
                          }}>
                            なし
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '12px' }}>{profile.name || '未設定'}</td>
                      <td style={{ padding: '12px' }}>{profile.occupation?.occupaionName || '未設定'}</td>
                      <td style={{ padding: '12px' }}>{profile.annual_income?.annualIncome || '未設定'}</td>
                      <td style={{ padding: '12px' }}>{new Date(profile.createdAt).toLocaleDateString('ja-JP')}</td>
                      <td style={{ padding: '12px,0px,12px,12px',   height:'100%'}}>
                        <div style={{display:'flex', alignItems:'center',}}>
                        <button
                          onClick={() => viewProfileDetails(profile)}
                          style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            padding: '10px 12px',
                            borderRadius: '3px',
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        >
                          詳細
                        </button>
                        <button
                          onClick={() => handleSendMessage(profile)}
                          style={{
                            backgroundColor: 'white',
                            color: '#2196F3',
                            border: 'none',
                            // padding: '10px 20px',
                            borderRadius: '5px',
                            marginTop:'5px',
                            marginLeft:'5px',
                            fontSize:'20px',
                            cursor: 'pointer'
                          }}
                        >
                        <IoIosSend  />
                        </button>
                        <HeartButton style={{marginLeft:'5px'}} userId={profile._id} />
                        </div>
                        
                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {searchResults.length === 0 && searchFilters.occupation && searchFilters.annual_income && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p>検索条件に一致するプロフィールが見つかりませんでした。</p>
        </div>
      )}

      {/* Profile Details Modal */}
      {showProfileDetailsModal && selectedProfile && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            width: '600px',
            justifyContent: 'space-between',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2>プロフィール詳細</h2>
              <button
                onClick={() => {
                  setShowProfileDetailsModal(false);
                  setSelectedProfile(null);
                }}
                style={{
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                閉じる
              </button>
            </div>
            
            <div style={{ display: 'flex', gap: '80px', marginBottom: '20px' ,justifyContent: 'space-between'}}>
              {selectedProfile.photoLink ? (
                <img 
                  src={selectedProfile.photoLink.photodatas || selectedProfile.photoLink} 
                  alt="Profile" 
                  onClick={() => handleAvatarClick(selectedProfile)}
                  style={{ 
                    marginLeft: '50px',
                    width: '150px', 
                    height: '150px', 
                    borderRadius: '50%',
                    objectFit: 'cover',
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                />
              ) : (
                <div style={{ 
                  marginLeft: '20px',
                  width: '150px', 
                  height: '150px', 
                  borderRadius: '50%', 
                  backgroundColor: '#ddd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  写真なし
                </div>
              )}
              
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 10px 0' }}>{selectedProfile.name || '未設定'}</h3>
                <p style={{ margin: '5px 0' }}><strong>ユーザーID:</strong> {selectedProfile.userID}</p>
                <p style={{ margin: '5px 0' }}><strong>職業:</strong> {selectedProfile.occupation?.occupaionName || '未設定'}</p>
                <p style={{ margin: '5px 0' }}><strong>年収:</strong> {selectedProfile.annual_income?.annualIncome || '未設定'}</p>
                <p style={{ margin: '5px 0' }}><strong>性別:</strong> {selectedProfile.gender === 'male' ? '男性' : '女性'}</p>
                <p style={{ margin: '5px 0' }}><strong>誕生日:</strong> {selectedProfile.birthday || '未設定'}</p>
                <p style={{ margin: '5px 0' }}><strong>住所:</strong> {selectedProfile.address || '未設定'}</p>
                <p style={{ margin: '5px 0' }}><strong>登録日:</strong> {new Date(selectedProfile.createdAt).toLocaleDateString('ja-JP')}</p>
              </div>
            </div>
            
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button
                onClick={() => handleSendMessage(selectedProfile)}
                style={{
                  backgroundColor: '#2196F3',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                メッセージ送信
              </button>
              <HeartButton userId={selectedProfile._id} />
            </div>
          </div>
        </div>
      )}

      {/* Message Modal */}
      {showMessageModal && selectedUser && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px 30px 10px 30px',
            borderRadius: '10px',
            width: '500px',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3>メッセージ送信</h3>
              <button
                onClick={() => {
                  setShowMessageModal(false);
                  setSelectedUser(null);
                  setMessage('');
                  setConversationHistory([]);
                  setFullConversationHistory([]);
                }}
                style={{
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                閉じる
              </button>
            </div> */}
            
            <div style={{ marginBottom: '20px' }}>
              <p><strong>送信先:</strong> {selectedUser.name || '未設定'} ({selectedUser.userID})</p>
            </div>
            
            {/* Conversation History */}
            {conversationHistory.length > 0 && (
              <div style={{
                marginBottom: '5px',
                maxHeight: '100px',
                overflowY: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px',
                padding: '5px',
                backgroundColor: '#f9f9f9'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#666' }}>
                    直前のやり取り
                  </div>
                  <button
                    onClick={openFullHistoryInNewTab}
                    style={{
                      backgroundColor: '#2196f3',
                      color: 'white',
                      border: 'none',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '11px'
                    }}
                  >
                    📋
                  </button>
                </div>
                {conversationHistory.slice(-1).map((msg) => {
                  // Check if message is from current user by comparing IDs
                  const isFromMe = msg.from_userID?._id === currentUserId;
                  return (
                    <div
                      key={msg._id}
                      style={{
                        marginBottom: '10px',
                        padding: '8px',
                        backgroundColor: isFromMe ? '#e3f2fd' : '#f5f5f5',
                        borderRadius: '5px',
                        borderLeft: `3px solid ${isFromMe ? '#2196f3' : '#4caf50'}`
                      }}
                    >
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                        {msg.from_userID?.name || '不明'} - {new Date(msg.created_at).toLocaleString('ja-JP')}
                      </div>
                      <div style={{ fontSize: '14px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {(msg.body || '').replace(/\[画像添付\]\n?/g, '').trim()}
                      </div>
                      {msg.images && msg.images.length > 0 && (
                        <MessageImages images={msg.images} style={{ maxHeight: '50px' }} />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            {loadingHistory && (
              <div style={{ marginBottom: '20px', textAlign: 'center', color: '#666' }}>
                会話履歴を読み込み中...
              </div>
            )}
            
            <div style={{ marginBottom: '3px' }}>
              {/* <label style={{ display: 'block', marginBottom: '5px' }}>メッセージ:</label> */}
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{
                  width: '94%',
                  height: '100px',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  resize: 'vertical'
                }}
                placeholder="メッセージを入力してください..."
              />
            </div>
            {/* Image Upload Section */}
            <div style={{  }}>
              {/* <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold', fontSize: '14px' }}>
                画像を添付（最大10枚、動画ファイルは除く）
              </label> */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* File selection button */}
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', }}>
                <label
                  style={{
                    border: '1px solid #3498db',
                    color: 'black',
                    padding: '8px 10px 0px 10px ',
                    borderRadius: '5px',
                    cursor: (isCompressingImages || selectedImages.length >= 10) ? 'not-allowed' : 'pointer',
                    fontSize: '20px',
                    display: 'inline-block',
                    opacity: (isCompressingImages || selectedImages.length >= 10) ? 0.6 : 1
                  }}
                >
                  <RiAttachment2 />
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageSelect}
                    disabled={isCompressingImages || selectedImages.length >= 10}
                    style={{ display: 'none' }}
                  />
                </label>
                {/* Camera button for mobile */}
                <label
                  style={{
                    border: '1px solid #27ae60',
                    color: 'black',
                    padding: '8px 10px 0px 10px ',
                    borderRadius: '5px',
                    cursor: (isCompressingImages || selectedImages.length >= 10) ? 'not-allowed' : 'pointer',
                    fontSize: '20px',
                    display: 'inline-block',
                    opacity: (isCompressingImages || selectedImages.length >= 10) ? 0.6 : 1
                  }}
                >
                  <BiCamera />
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handleImageSelect}
                    disabled={isCompressingImages || selectedImages.length >= 10}
                    style={{ display: 'none' }}
                  />
                </label>
                </div>
                <div style={{  }}>
              <button
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                style={{
                  backgroundColor: '#ff9800',
                  color: 'white',
                  border: 'none',
                  padding: '8px 8px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  marginRight: '10px'
                }}
              >
                😊 絵文字
              </button>
            </div>
              </div>
              {isCompressingImages && (
                <div style={{ color: '#666', fontSize: '12px', marginBottom: '10px' }}>
                  画像を圧縮中...
                </div>
              )}
              {imagePreviewUrls.length > 0 && (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
                  gap: '10px',
                  marginTop: '10px'
                }}>
                  {imagePreviewUrls.map((url, index) => (
                    <div key={index} style={{ position: 'relative' }}>
                      <img
                        src={url}
                        alt={`Preview ${index + 1}`}
                        style={{
                          width: '100%',
                          height: '100px',
                          objectFit: 'cover',
                          borderRadius: '5px',
                          border: '1px solid #ddd'
                        }}
                      />
                      <button
                        onClick={() => removeImage(index)}
                        style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                          backgroundColor: '#e74c3c',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
                
              )}
            </div>
            
          
            {/* Schedule controls */}
            <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              {/* <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <input type="checkbox" checked={enableSchedule} onChange={(e) => setEnableSchedule(e.target.checked)} />
                後で送信を予約する
              </label> */}
              {enableSchedule && (
                <input
                  type="datetime-local"
                  value={scheduledAt}
                  onChange={(e) => setScheduledAt(e.target.value)}
                  style={{ padding: '6px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              )}
            </div>
            
            {showEmojiPicker && (
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '10px',
                padding: '10px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                zIndex: 1001,
                maxWidth: '80%',
                maxHeight: '100%',
                overflow: 'auto'
              }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px' }}>
                  {emojis.map((emoji, index) => (
                    <button
                      key={index}
                      onClick={() => addEmoji(emoji)}
                      style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        fontSize: '20px',
                        cursor: 'pointer',
                        padding: '5px',
                        borderRadius: '5px',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      {emoji}
                    </button>
                  ))}
                </div>
                {/* <button
                  onClick={() => setShowEmojiPicker(false)}
                  style={{
                    position: 'fixed',
                    top: '10px',
                    right: '10px',
                    backgroundColor: '#e74c3c',
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    cursor: 'pointer'
                  }}
                >
                  ✕
                </button> */}
              </div>
            )}
            
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowMessageModal(false);
                  setSelectedUser(null);
                  setMessage('');
                  setSelectedImages([]);
                  setImagePreviewUrls([]);
                  setConversationHistory([]);
                }}
                style={{
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                キャンセル
              </button>
              <button
                onClick={sendMessage}
                disabled={!message.trim() && selectedImages.length === 0}
                style={{
                  backgroundColor: (message.trim() || selectedImages.length > 0) ? '#4CAF50' : '#95a5a6',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: (message.trim() || selectedImages.length > 0) ? 'pointer' : 'not-allowed'
                }}
              >
                {enableSchedule && scheduledAt ? '予約' : '送信'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Avatar Modal */}
      {showAvatarModal && selectedAvatar && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '10px',
            maxWidth: '90vw',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '20px' }}>
              <h3 style={{ margin: 0 }}>プロフィール画像</h3>
              {/* <button
                onClick={() => {
                  setShowAvatarModal(false);
                  setSelectedAvatar(null);
                }}
                style={{
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                閉じる
              </button> */}
            </div>
            
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
              <p style={{ margin: '0 0 10px 0', fontSize: '16px' }}>
                <strong>{selectedAvatar.name}</strong> ({selectedAvatar.userID})
              </p>
            </div>
            
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
              <img 
                src={selectedAvatar.src} 
                alt="Profile Avatar" 
                style={{ 
                  maxWidth: '400px',
                  maxHeight: '400px',
                  borderRadius: '10px',
                  objectFit: 'contain',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                }} 
              />
            </div>
            
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={downloadAvatar}
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '25px'
                }}
              >
                <AiOutlineDownload />
              </button>
              <button
                onClick={() => {
                  setShowAvatarModal(false);
                  setSelectedAvatar(null);
                }}
                style={{
                  backgroundColor: '#666',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileSearch; 